define(function(require) {
  // general
  const CommonInspectionCode = require('civicsViews/inspection_request/common/common');
  const CommonReviewCode = require('civicsViews/assign_review/common/common');
  const CN = require('civicsUtils/constants');
  // templates
  const tpl = require('civicsViews/code_violations/templates/t_lov_violations.hbs');
  // views
  const ViolationsCompositeView = require('civicsViews/code_violations/v_cpv_violations');

  return Marionette.LayoutView.extend({
    initialize: function(options) {
      if (__DEV__) console.log('lov_violations -- initialize');
      this.config = options.config;
      this.config.isInspection = options.isInspection;
      this.collection = options.collection;
      this.currentSort = options.initialViolationsSort;
      this.applicationModel = options.applicationModel;
      this.showAllItems = false;
      this.expanded = {value:false};
    },
    template: tpl,
    regions: {
      tableViewRegion: '@ui.desktopView',
    },
    ui: {
      btnFinishRecordingResults: '.btn-finish-recording-results',
      btnRecordResults: '.btn-record-results',
      desktopView: '.activity-violations-table',
      content: '.content',
      noContent: '.no-content',
      btnSortResolution: '.btnSortResolution',
      iconSortResolution: '.icon-sort-resolution',
    },
    events: {
    'click @ui.btnRecordResults': 'recordResultsClicked',
    'click @ui.btnFinishRecordingResults': 'recordResultsClicked',
    'click @ui.btnSortResolution': 'sortByResolutionClicked',
    },
    onRender: function() {
      if (__DEV__) console.log('lov_violations -- onRender');
      if (this.collection.length <= 0) {
        //this.ui.content.hide();
        this.ui.noContent.show();
      } else {
        this.ui.content.show();
        this.ui.noContent.hide();
      }
      this.$el.rhythmThemeInit();
    },
    onShow: function() {
      if (__DEV__) console.log('lov_violations -- onShow');

      // Logs Composite View
      this.violationsCompositeView = new ViolationsCompositeView({
        config: this.config,
        collection: this.collection,
        currentSort: this.currentSort,
        showAllItems: this.showAllItems,
        expanded: this.expanded
      });
      this.tableViewRegion.show(this.violationsCompositeView);
      this.$el.rhythmThemeInit();
    },

    sortByResolutionClicked: function() {
      if (__DEV__) console.log('cpv_violations sortByResolutionClicked');
      this.currentSort.field = 'violationStatusDescription';
      this.currentSort.direction = this.ui.iconSortResolution.hasClass('up') ? CN.SORT_DESC : CN.SORT_ASC;
      this.collection.sort(this.currentSort.field, this.currentSort.direction);
      this.ui.iconSortResolution.toggleClass('up down');
      this.ui.iconSortResolution.hasClass('up') ? this.ui.iconSortResolution.closest('.col').attr('aria-sort','ascending') : this.ui.iconSortResolution.closest('.col').attr('aria-sort','descending');
    },
    isDesktopViewVisible: function() {
      return this.ui.desktopView.css('display') != 'none';
    },
    recordResultsClicked:function(){
        App.sessionStorage.set('CIVICS', 'PREV_PAGE', document.URL.urlPath().toString());//store url in session storage
    },
    templateHelpers: function() {
      var self = this;
      var helpers = {
        count: self.collection.length,
        isRecordingPartiallyComplete: function() {
          if (self.config.isInspection) {
            return this.isInspectionRecordingPartiallyComplete();
          } else {
            return this.isReviewRecordingPartiallyComplete();
          }
        },
        recordResultsTargetPage: function() {
          if (typeof self.config.recordResultsTargetPage == 'undefined') {
            return 'error_no_target_page_defined';
          }
          if(self.config.fromServer.reviewId){//if review
			  return 'onclick="location.href=\''+self.config.recordResultsTargetPage.urlPath({
				  type:CN.RECORD_TYPES()[self.config.fromServer.instrumentType.toLowerCase()],
				  id:self.config.fromServer.reviewId,
				  rev:'y'
			  })+'\'"';
          } else {//inspection
			  return 'onclick="location.href=\''+self.config.recordResultsTargetPage.urlPath({
				  type:CN.RECORD_TYPES()[self.config.fromServer.instrumentType.toLowerCase()],
				  id:self.config.fromServer.inspectionId
			  })+'\'"';
          }
        },
        showComments: function() {
          return !self.config.isPublic;
        },
        showRecordResultsButton: function() {
          if (self.config.isInspection) {
            return self.config.isProvider && this.isInspectionOpen;
          } else {
            return self.config.isProvider && this.isReviewOpen;
          }
        },
        showRecordResultsButtonDisabled: function() {
          if (self.config.isInspection) {
            return this.isInspectionScheduled ? false : true;
          } else {
            return false;
          }
        },
      };

      // Add the common helpers
      if (this.config.isInspection) {
        _.extend(helpers, CommonInspectionCode.commonHelpers(this));
      } else {
        _.extend(helpers, CommonReviewCode.commonHelpers(this));
      }
      return helpers;
    },
  });
});
